import PropTypes from 'prop-types';

import { useDonationContextProvider } from 'context/DonationContextProvider';

import { CoverTransactionFee } from '../CoverTransactionFee';
import { Button } from 'react-bootstrap';
import { formatMoney } from 'helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

function DonationSummary({ onCheckout, onClickBack, isProcessing }) {
  const { basket, totalAmount } = useDonationContextProvider();

  return (
    <aside className="d-flex flex-column gap-2">
      <h2 className="text-uppercase wr-donation-header3 mb-3">
        donation summary
      </h2>
      <div className="d-flex flex-column gap-3 mb-3">
        {basket.map(donation => (
          <DonationItem key={donation.id} donation={donation} />
        ))}
      </div>
      <p className="mb-2 wr-donation-body2 wr-donation-text-brand-secondary">
        Help us further
      </p>
      <CoverTransactionFee />
      <div className="wr-donation-summary-card d-flex flex-column gap-3">
        <header className="wr-donation-text-brand-secondary fw-bold d-flex justify-content-between align-items-center">
          <span>Total</span>
          <span>{formatMoney(totalAmount, '£')}</span>
        </header>
        <Button
          className="border-0 bg-wr-donation-success-500 py-3 fw-bold"
          onClick={onCheckout}
          disabled={isProcessing}
        >
          {isProcessing ? 'Processing...' : 'Continue to Payment >'}
        </Button>
        <Button
          className="border-0 bg-wr-donation-grey-150 wr-donation-text-grey-800 py-3"
          onClick={onClickBack}
        >
          &lt; Back
        </Button>
      </div>
    </aside>
  );
}

export function DonationItem({ donation }) {
  const { paymentType, count, donationAmount, donationType } = donation;
  const { setIsCartDrawerOpen } = useDonationContextProvider();

  return (
    <div className="wr-donation-summary-card d-flex flex-column gap-3 position-relative">
      <Button 
        className="position-absolute p-1 bg-transparent border-0"
        onClick={() => setIsCartDrawerOpen(true)}
        aria-label="Edit donation"
        style={{ top: '8px', right: '8px', width: '30px', height: '30px' }}
      >
        <FontAwesomeIcon icon={faEdit} className="text-primary" size="sm" />
      </Button>
      <header className="d-flex justify-content-between align-items-center wr-donation-text-brand-secondary pt-4">
        <p className="text-capitalize mb-0 fw-semi-bold fs-1">
          {donation.packageId ? donation.packageName : 'Quick Donation'}
        </p>
        <span className="fs-2 fw-semi-bold">
          {formatMoney(count * donationAmount.value, '£')}
        </span>
      </header>
      <ul>
        <li>{paymentType.charAt(0).toUpperCase() + paymentType.slice(1)}</li>
        <li>{donationType.name}</li>
      </ul>
    </div>
  );
}

DonationSummary.propTypes = {
  onCheckout: PropTypes.func.isRequired,
  onClickBack: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool
};
DonationItem.propTypes = {
  donation: PropTypes.object.isRequired
};
export { DonationSummary };
